const SUB_CATEGORY_ACTION_TYPES = {
  LOAD_SUB_CATEGORY: 'subCategory/LOAD_SUB_CATEGORY',
};

export default SUB_CATEGORY_ACTION_TYPES;
